import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS_MUTATION } from '../graphql/mutations'
import { SCRAPING_REVIEW_COMMENTS_QUERY } from '../graphql/queries'
import {
  FETCH_SCRAPING_REVIEW_COMMENTS,
  UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS,
} from '../redux/action-types'

const useUpdateMenuCurationTaskScrapingReviewStatusMutation = () => {
  const dispatch = useDispatch()

  const { isUpdateScrapingReviewStatusLoading: isLoading, updateError: error } =
    useSelector(store => store.menuCurationTasks.menuCurationTask)

  const handleSuccess = useCallback(
    id =>
      apolloService.query({
        query: SCRAPING_REVIEW_COMMENTS_QUERY,
        variables: {
          id,
        },
        dispatch,
        action: FETCH_SCRAPING_REVIEW_COMMENTS,
      }),
    [dispatch],
  )

  const mutate = useCallback(
    (id, action, comment) =>
      apolloService.mutate({
        mutation: UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS_MUTATION,
        variables: { id, action, comment },
        dispatch,
        action: UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS,
        onSuccess: () => handleSuccess(id),
      }),
    [dispatch, handleSuccess],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateMenuCurationTaskScrapingReviewStatusMutation
